export default __webpack_public_path__ + "static/media/location.4a25808b.png";